import type { JoinSession } from './ConferenceRoomGate.types'

export function validateJoinSession(session: JoinSession, now = Date.now()): string | null {
  try {
    const url = new URL(session.roomUrl)
    if (url.protocol !== 'https:') return 'invalid_room_url'
  } catch { return 'invalid_room_url' }
  if (session.token.length < 16 || session.token.length > 8192) return 'invalid_join_token'
  if (session.expiresAt) {
    const expiration = Date.parse(session.expiresAt)
    if (!Number.isFinite(expiration) || expiration <= now + 5_000) return 'join_token_expired'
  }
  return null
}

export function humanizeJoinError(reason?: string): string {
  const key = reason?.toLowerCase() ?? 'join_failed'
  if (key.includes('not_authorized') || key.includes('denied')) return 'You are not authorized to join this meeting.'
  if (key.includes('expired')) return 'The join authorization expired. Return and request a new one.'
  if (key.includes('provider_not_configured')) return 'The video provider is not configured for this environment.'
  if (key.includes('migration') || key.includes('schema')) return 'The meeting schema is not ready in this environment.'
  if (key.includes('cancel')) return 'This meeting was cancelled.'
  if (key.includes('not_found')) return 'The meeting could not be found.'
  if (key.includes('waiting_room_admission_required')) return 'Waiting for the host to admit you.'
  if (key.includes('waiting_room_left')) return 'You left the waiting room.'
  if (key.includes('waiting_room_expired')) return 'Your waiting-room session expired. Return to Conference Calls and try again.'
  return 'The meeting could not be opened. Return to Conference Calls and try again.'
}
